export const isInExtension = () => Boolean(window.chrome?.runtime?.id)

export function isExtensionSupported() {
  return navigator.userAgent.indexOf('Chrome') !== -1
}
